// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3wOxy","filesListContainer":"PosDisputesFiles_filesListContainer__1PimU","filesButton":"PosDisputesFiles_filesButton__1UG54"};